<div [formGroup]="userFormInput" *ngIf="userFormInput">
    <mat-form-field class="mat-field-width">
        <input matInput placeholder="Your full name" formControlName="fullName" />
        <ng-container *ngIf="userForm['fullName'].errors && userForm['fullName'].touched">
            <mat-error *ngIf="userForm['fullName'].errors['required']">A name is required</mat-error>
        </ng-container>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
        <input matInput placeholder="Mobile number" formControlName="mobileNumber" />
        <ng-container *ngIf="userForm['mobileNumber'].errors && userForm['mobileNumber'].touched">
            <mat-error *ngIf="userForm['mobileNumber'].errors['required']">A mobile number is required</mat-error>
        </ng-container>
    </mat-form-field>
    <div *ngIf="!existing">
        <mat-form-field class="mat-field-width">
            <input matInput placeholder="Email address is the user login" formControlName="email" />
            <ng-container *ngIf="userForm['email'].errors && userForm['email'].touched">
            <mat-error *ngIf="userForm['email'].errors['existingEmail']">Email address cannot be used</mat-error>
            <mat-error *ngIf="userForm['email'].errors['required']">Email address is required</mat-error>
            <mat-error *ngIf="userForm['email'].errors['complexityError']">Invalid email address</mat-error>
            </ng-container>
        </mat-form-field>
     
        <mat-form-field class="mat-field-width">
            <input type="password" matInput placeholder="Must have min 8 characters, 1 upper, lower, numeric and non-alpha"
                formControlName="password" />
            <ng-container *ngIf="userForm['password'].errors && userForm['password'].touched">
            <mat-error *ngIf="userForm['password'].errors['complexityError']">Please make the password more complex</mat-error>
            <mat-error *ngIf="userForm['password'].errors['required']">Password is required</mat-error>
            </ng-container>
        </mat-form-field>
        <mat-form-field class="mat-field-width">
            <input type="password" matInput placeholder="Please confirm the password" formControlName="confirmPassword" />
            <ng-container *ngIf="userForm['confirmPassword'].errors && userForm['confirmPassword'].touched">
            <mat-error *ngIf="userForm['confirmPassword'].errors['mismatchedPassword']">Password does not match</mat-error>
            <mat-error *ngIf="userForm['confirmPassword'].errors['required']">Password confirmation is required</mat-error>
            </ng-container>
        </mat-form-field>
    </div>
  </div>
  